<template>
    <div class="draws">
        <div class="draws__head">
            {{ step === 1 ? getTranslatedText("Draws") : getTranslatedText("Past Draws") }}
        </div>
        <div class="loading-full-page" v-if="isLoadingPage">
            <b-card>
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
            </b-card>
        </div>
        <div v-else class="draws__contents">
            <div v-if="step === 1" class="draws__content__winnings">
                <div class="draws__content__past__title">
                    {{ getTranslatedText("winnings") }}
                </div>
                <NoEmpty
                    v-if="listWinnings.length === 0"
                    :text="getTranslatedText('no data')"
                />
                <div v-else class="draws__content__winnings__list">
                    <div
                        v-for="(item, i) in listWinnings"
                        :key="i"
                        class="draws__content__winnings__item"
                    >
                        <p class="draws__content__winnings__item__text">
                            {{ getTranslatedText(item.name) }}
                        </p>
                        <p class="draws__content__winnings__item__price">
                           {{ getTranslatedText(currencyCode) }} {{ fomarNumberWinners(item.prize) }}
                        </p>
                    </div>
                </div>
                <p class="draws__content__winnings__text-note">{{ getTranslatedText('grand prize can reach up to [grand_prize] omr', {
                    grand_prize: renderNumber(10000000)
                }) }}</p>
            </div>

            <div class="draws__content__past">
                <ButtonCustom
                    v-if="step === 2"
                    classBtn="draws__content__past__button-to-back"
                    type="go-back"
                    :text="getTranslatedText('back to draws')"
                    :isGoBackHistory="false"
                    @onClickButton="onShowListDraws"
                />
                <div class="draws__content__past__header" v-else>
                    <div class="draws__content__past__title">
                        {{ getTranslatedText("Past Draws") }}
                    </div>
                    <ButtonCustom
                        v-if="listPastDrawsALl.length > 0"
                        classBtn="draws__content__past__button-view-all"
                        typeBtn="button"
                        type="primary"
                        @onClickButton="onShowListDraws"
                        text="View All"
                        icon="icon-drop-down.png"
                    />
                </div>
                 <NoEmpty
                    v-if="listPastDrawsALl.length === 0"
                    :text="getTranslatedText('no data')"
                />
                <div v-else class="draws__content__past__list" >
                        <div
                            v-for="(item, i) in step === 1 ? listPastDraws : listPastDrawsALl"
                            :key="i"
                            class="draws__content__past__item"
                        >
                            <div class="draws__content__past__item__date">
                                {{ formatDate(item.draw_date, 'DD / MM / YYYY')}}
                            </div>
                            <p class="draws__content__past__item__title">
                                {{ getTranslatedText('winning number') }}
                            </p>
                            <div class="draws__content__past__item__numbers winning">
                                    <div
                                        v-for="(number, index) in item.results[0]"
                                        :key="index"
                                        :class="`draws__content__past__item__numbers__number ${renderClass(
                                            number,
                                            index
                                        )}`"
                                    >
                                        <div
                                            class="draws__content__past__item__numbers__number__box"
                                        >
                                            <a>{{ renderNumber(Number(number)) }}</a>
                                        </div>
                                    </div>
                            </div>
                             <p class="draws__content__past__item__title">
                                {{ getTranslatedText('winning raffle') }}: <span>{{ item.raffle_winning_code }}</span>
                            </p>
                        </div>
                     <ButtonCustom
                        v-if="step === 1"
                        classBtn="draws__content__past__button-view-all mobile"
                        typeBtn="button"
                        type="primary"
                        @onClickButton="onShowListDraws"
                        text="View All"
                        icon="icon-drop-down.png"
                    />
                </div>
            </div>
            <div class="draws__content__content-bottom__last__container">
                <div class="draws__content__content-bottom__last">
                    <div class="draws__content__content-bottom__last__text">
                        {{ getTranslatedText("Watch Live Draw")}}
                        <div class="draws__content__content-bottom__last__sub-text">
                            {{ getTranslatedText("Watch our weekly draws every")}}
                        </div>
                    </div>
                    <a
                        :href="linkWatchNow"
                        target="_blank"
                        class="draws__content__content-bottom__last__button"
                        :class="{
                            'past-draws__content__content-bottom__last__button__arabic':
                                $store.state.isRtl,
                        }"
                    >
                        {{ getTranslatedText("Watch Now") }}
                        <img
                            src="@/assets/images/static-pages/icon-join-us.png"
                        />
                    </a>
                </div>
            </div>
            <!-- <div class="draws__content__winner">
                <div class="draws__content__past__title title-winner">
                    {{ getTranslatedText("Winners hall of fame") }}
                </div>
                <div
                    v-for="(winner, k) in listWinners"
                    :key="k"
                    class="draws__content__winner__item"
                >
                    <div class="draws__content__winner__item__left">
                        <div class="draws__content__winner__item__left__avatar">
                            <img v-if="winner.avatar" :src="winner.avatar" />
                            <img
                                v-else
                                src="@/assets/images/personal-detail/avatar.png"
                            />
                        </div>
                        <div class="draws__content__winner__item__left__name">
                            <div
                                class="draws__content__winner__item__left__name__text"
                            >
                                {{ winner.full_name }}
                            </div>
                            <div
                                class="draws__content__winner__item__left__time"
                            >
                                {{ formatDate(winner.date, 'DD-MMMM-YYYY')}} {{ getTranslatedText(winner.game_name) }}
                            </div>
                            <div
                                class="draws__content__winner__item__right__mobile"
                            >
                                {{ getTranslatedText("Winner of") }}
                                <span
                                    >{{ fomarNumberWinners(winner.winnings) }}
                                    {{ winner.currency }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="draws__content__winner__item__right">
                        {{ getTranslatedText("Winner of") }}
                        <span
                            >{{ fomarNumberWinners(winner.winnings) }}
                            {{ getTranslatedText(winner.currency) }}</span
                        >
                    </div>
                </div>
                <div
                    @click="getWinners(null)"
                    class="draws__content__past__item winner-view-all"
                >
                    <div class="draws__content__past__item__view-all">
                        {{ getTranslatedText("View All") }}
                    </div>
                    <div class="draws__content__past__item__icon">
                        <img
                            src="@/assets/images/personal-detail/icon-right.png"
                        />
                    </div>
                </div>
            </div> -->

            <!-- <div class="draws__content__watch">
                <div class="draws__content__watch__title">
                    <a href="https://www.youtube.com/channel/UCCZxGo-Fgh-Vd47jxUBjnww" target="_blank" class="draws__content__watch__title__text">
                        {{ getTranslatedText("Watch live draw") }}
                    </a>
                    <div
                        @click="onClickMoveToYT"
                        class="draws__content__watch__title__icon"
                    >
                        <img
                            src="@/assets/images/personal-detail/icon-right.png"
                        />
                    </div>
                </div>
                <div class="draws__content__watch__des">
                    {{ getTranslatedText("Watch our weekly draws every") }}
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import { isArrayEmpty, isStrEmpty, renderClassBall, renderLocaleNumber, uniqByKeepFirst } from "@/components/common/utils";

import moment from "moment";

import DrawsService from "@/services/draws.service";
import toolService from '@/services/tool.service';
import languageMixin from "@/mixins/language/language-mixin";

import ButtonCustom from "@/components/common/button";
import NoEmpty from "@/components/common/no-empty";

const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;
const LINK_WATCH_NOW = process.env.VUE_APP_LINK_WATCH_NOW;


export default {
    mixins: [languageMixin],
    components: { ButtonCustom, NoEmpty },
    data() {
        return {
            linkWatchNow: LINK_WATCH_NOW,
            listWinnings: [],
            listPastDraws: [],
            currencyCode: CURRENCY_CODE,
            maxiumBlue: 0,
            maxiumGreen: 0,
            minimumBall: 0,
            listPastDrawsALl: [],
            step: 1,
            isLoadingPage: true,
        };
    },
    mounted() {
        this.getListPastDraws();
        this.fetchDataValidateBall();
        this.getListDraws();
        this.$store.dispatch("getListGame");
    },
    methods: {
        async fetchDataValidateBall() {
            try {
                const resp = await toolService.getValidateTicket();
                this.maxiumBlue = resp.maxiumBlue;
                this.maxiumGreen = resp.maxiumGreen;
                this.minimumBall = resp.minMaxTickets[0];

            } catch (err) {
                console.log(err, "err");
            }
        },

        // async getTimeWatchLive() {
        //     if(!isStrEmpty(localStorage.getItem("list_games"))) {
        //         let listGames = localStorage.getItem("list_games");
        //         let data = JSON.parse(listGames);
        //         this.timeDraws = data[0].draw_date;
        //     } else {
        //         try {
        //             const resp = await gameService.getLottoGames("4");
        //             if(resp.status === 200 && !isArrayEmpty(resp.data)) {
        //                 this.timeDraws = resp.data[0].draw_date;
        //             }
        //         } catch (error) {
        //             console.log(error)
        //         }
        //     }
        // },
        
        formatDate(value, type) {
            let locale = this.$store.state.isRtl ? "ar" : "en";
            moment.locale(locale);
            return !isStrEmpty(value) ? moment(value).format(type) : '';
        },

        async getListPastDraws() {
            try {
                const resp = await DrawsService.listPastDraws()
                if(resp.status === "success" && !isArrayEmpty(resp.data) && !isArrayEmpty(this.$store.state.listGameLoto)) {
                    resp.data[0].tiers[0].prize = this.$store.state.listGameLoto[0].estimated_jackpot
                    resp.data[0].tiers.push({
                        name: 'raffle id match',
                        prize: "10000"
                    })
                   
                    this.listWinnings = resp.data[0].tiers
                    this.isLoadingPage = false
                } else {
                    this.isLoadingPage = false
                }
            } catch (error) {
                console.log(error)
            }
        },

        getListDraws() {
            DrawsService.listDraws(this.perPageDraws, this.page).then((res) => {
                if (res.status === 200 && !isArrayEmpty(res.data)) {
                    let listDraws = res.data.map(x => {
                        let item = {
                            ...x, 
                            results: JSON.parse(x.results),
                            raffle_winning_bet: JSON.parse(x.raffle_winning_bet)
                        }
                        return {
                            ...item
                        }
                    })
                    this.listPastDrawsALl = listDraws
                    this.listPastDraws = listDraws.slice(0, 3)
                }
            });
        },

        submitListDraws() {
            this.$router.push("/list-draws");
        },

        getListWinners() {
            DrawsService.listWinners(this.perPageWinner, null).then((res) => {
                if (res.status === 200) {
                    this.listWinners = res.data;
                }
            });
        },

        pastDraws(item) {
            this.$router.push({name: 'PastDraws', query: { eventID: item.event_id } });
        },

        getWinners(id) {
            this.$router.push({ name: "Winners", query: { id } });
        },

        fomarNumberWinners(price) {
            price = renderLocaleNumber(parseFloat(price))
            return price;
        },

        formatPrice(price) {
            return parseFloat(price).toLocaleString('en-US');
        },

        onClickMoveToYT() {
            window.open('https://www.youtube.com/channel/UCCZxGo-Fgh-Vd47jxUBjnww', "_blank")
        },

        renderClass(number, index) {
            return renderClassBall(
                number,
                index,
                this.minimumBall,
                this.maxiumBlue,
                this.maxiumGreen
            );
        },

        renderNumber(number) {
            return renderLocaleNumber(number);
        },

        onShowListDraws() {
            this.isLoadingPage = true
            this.step = this.step === 1 ? 2 : 1
            setTimeout(() => {
                this.isLoadingPage = false
            }, 500)
        }
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/static-pages/draws.scss" />
